import React from "react";
import { Editor, EditorState, convertFromRaw, CompositeDecorator } from "draft-js";
import "draft-js/dist/Draft.css";

const Link = (props) => {
  const { url } = props.contentState
    .getEntity(props.entityKey)
    .getData();

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        color: "#1976d2",
        textDecoration: "underline",
        cursor: "pointer",
      }}
    >
      {props.children}
    </a>
  );
};

const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(
    (character) => {
      const entityKey = character.getEntity();

      return (
        entityKey !== null &&
        contentState.getEntity(entityKey).getType() === "LINK"
      );
    },
    callback
  );
};

const decorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link,
  },
]);

const styleMap = {
  H1: { fontSize: "32px", fontWeight: "bold" },
  H2: { fontSize: "24px", fontWeight: "bold" },
};

const TncViewer = ({ tnc }) => {

  // If no data
  if (!tnc) {
    return <div>No T&C Available</div>;
  }

  let editorState;

  try {
    const parsedData =
      typeof tnc === "string" ? JSON.parse(tnc) : tnc;

    const contentState = convertFromRaw(parsedData);

    editorState = EditorState.createWithContent(contentState, decorator);
  } catch (error) {
    console.log("Invalid TNC JSON", error);
    return <div>Invalid T&C Data</div>;
  }

  return (
    <div
      style={{
        border: "1px solid #ddd",
        padding: "16px",
        borderRadius: "8px",
      }}
    >
      <Editor
        editorState={editorState}
        customStyleMap={styleMap}
        readOnly={true}
        toolbarHidden={true}
      />
    </div>
  );
};

export default TncViewer;